"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const translate_1 = require("components/translate");
const moduleService_1 = require("modules/content/moduleService");
const PAGE_TYPES = {
    [moduleService_1.PageType.Advertisement]: {
        label: 'general.upsell',
        icon: 'badge-dollar'
    },
    [moduleService_1.PageType.Content]: {
        label: 'general.content',
        icon: 'page'
    },
    [moduleService_1.PageType.Quiz]: {
        label: 'general.quiz',
        icon: 'square-question'
    },
    [moduleService_1.PageType.Webinar]: {
        label: 'general.webinar',
        icon: 'signal-stream'
    }
};
const PageTypeBadge = ({ t, pageType, className }) => {
    const { label, icon } = PAGE_TYPES[pageType];
    return ((0, jsx_runtime_1.jsxs)("span", { className: (0, classnames_1.default)('_d-flex _align-items-center _text-gray-500 _text-1', className), children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', icon], className: "_mr-1" }), (0, jsx_runtime_1.jsx)("span", { children: t(label) })] }));
};
exports.default = (0, translate_1.translate)()(PageTypeBadge);
